import { array, object, string } from "yup";

export const mergeCategoriesSchema = object({
  mergeCategories: array()
    .of(string().required())
    .min(2, "Please select at least 2 categories"),
  primary_category: string().required("Please select primary category"),
});
